/**
 * Cytoscape's expand-collapse plugin stores live `Collection` references on
 * node `data` (e.g. `collapsedChildren`). Those Collections cycle back to the
 * Cytoscape Core, so any naive `JSON.stringify(node.data)` throws
 * `Converting circular structure to JSON` and the call site silently breaks.
 *
 * Use these helpers instead of `JSON.parse(JSON.stringify(...))` whenever the
 * input may contain Cytoscape node/edge data — clipboard, sidebar snapshots,
 * duplicate flows, etc. (MAP-1352, MAP-1435).
 */

const NON_SERIALIZABLE_CY_KEYS = new Set(['collapsedChildren']);

export function safeStringify(value: unknown): string {
  return JSON.stringify(value, (key, val) =>
    NON_SERIALIZABLE_CY_KEYS.has(key) ? undefined : val,
  );
}

export function safeDeepClone<T>(value: T): T {
  return JSON.parse(safeStringify(value)) as T;
}
